import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Me'),_c('Navbar'),_c(VMain,[_c(VContainer,{staticClass:"no-padding",attrs:{"fluid":"","id":"app"}},[_c('EmploymentView')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }